import Marionette from 'backbone.marionette';
import MemberVotesItemviewTmpl from '../templates/member_votes_itemview.tpl';
export default Marionette.ItemView.extend({
  template: MemberVotesItemviewTmpl,
  tagName: "tr",
  className: "member-vote"
});